import React from 'react'
import { Route, IndexRoute } from 'react-router'
import Cookies from 'js-cookie'

import Layout from '../component/Layout'
import EmptyLayout from '../component/EmptyLayout'
import Auth from '../component/Auth'
import LoginPage from '../component/dump/forms/login/LoginPage'
import ConfirmationPage from '../component/dump/forms/login/ConfirmationPage'
import RestorePasswordPage from '../component/dump/forms/login/RestorePasswordPage'
import ChangePasswordPage from '../component/dump/forms/login/ChangePasswordPage'
import NotFoundComponent from '../component/dump/NotFoundComponent'
import HomeAccess from '../component/smart/menuComponentsContainer/HomeAccess';
import ChangePasswordContainer from '../component/smart/menuComponentsContainer/ChangePasswordContainer'
import CompanyContainer from '../component/smart/menuComponentsContainer/CompanyContainer'
import CompanyEditContainer from '../component/smart/menuComponentsContainer/CompanyEditContainer'
import AccountUserContainer from '../component/smart/account/AccountUserContainer'
import AccountChangePasswordContainer from '../component/smart/account/AccountChangePasswordContainer'
import AccountPasswordRecoveryContainer from '../component/smart/account/AccountPasswordRecoveryContainer'
import AccountSettings from '../component/smart/account/AccountSettings'
import SupportContainer from '../component/smart/menuComponentsContainer/SupportContainer'
import ManageVehicles from '../component/smart/menuComponentsContainer/ManageVehicles'

function loggedIn() {
	return new Auth().isUserAuthenticated();
}

function requireAuth(nextState, replace) {
	// console.log('requireAuth1: ', nextState)
	// console.log('requireAuth2: ', replace)
	// console.log('requireAuth3: ', Cookies.get())

	if (location.hash) {
		new Auth().authenticateUser(true, location.hash.slice(1), 1);
		window.location.assign("/");
	}

	if (nextState.location.query.ex) {
		new Auth().authenticateUser(true, 1, 1);
		location.href = nextState.location.pathname
	}
	else {
		if (!loggedIn()) {
			replace({
				pathname: '/login'
			})
		}
	}
}

export default (
	<Route>
		<Route component={EmptyLayout}>
			<Route path="/login" component={LoginPage} />
			<Route path="/restore-password" component={RestorePasswordPage} />
			<Route path="/change-password" component={ChangePasswordPage} />
			<Route path="/not-found" component={NotFoundComponent} />
			<Route path="/confirmation" component={ConfirmationPage} />
		</Route>
		<Route exact name="Home" path="/" component={Layout} onEnter={requireAuth}>
			<IndexRoute exact name="Home" component={HomeAccess} />
			<Route path="support" component={SupportContainer} />
			<Route path="managevehicles" component={ManageVehicles} />
			<Route path="/account/settings" component={AccountSettings} />
			<Route path="/account/change-password" component={AccountChangePasswordContainer} />
			<Route path="/account/password-recovery" component={AccountPasswordRecoveryContainer} />
			<Route path="manageusers/change-password" component={ChangePasswordContainer} />
			<Route path="/company" component={CompanyContainer} />
			<Route path="/company/edit" component={CompanyEditContainer} />
			<Route path="/account" component={AccountUserContainer} />
		</Route>
	</Route>
)
